import React from 'react'
import { Typography } from '@material-ui/core'

const NotFoundPage = () => (
  <Typography variant="h5">Not found</Typography>
)

export default NotFoundPage
